<template>
  <div>
    <keep-alive>
      <component :is="coms" :cutcoms="cutcoms"></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: 0,
      details: "", //是否是详情。
      videoinfo: {}, //考试的信息详情
      indexState: "", // 判断是添加还是编辑还是详情
      courseware: "courseware", //课件专属判断
      videoid: "",
      surplus: "", // 可用容量
    };
  },
  components: {
    CertifiedHosp: () => import("./page.vue"),
    isedit: () => import("./components/index.vue"),
    studySituation: () => import("../videoware/studySituation.vue"),
  },
  computed: {
    coms() {
      switch (this.isActive) {
        case 0:
          return "CertifiedHosp";
        case 1:
          return "isedit";
        case 2:
          return "studySituation";
      }
      return "ss";
    },
  },
  methods: {
    cutcoms(index) {
      if (this.indexState == 0 && this.isActive == "1") {
        // 新增
        this.$children[0].Buriedpoint({
          code: "Resource:Resources:upload",
          parent_code: "Resource:Resources",
        });
      } else if (this.indexState == 1 && this.isActive == "1") {
        // 编辑
        this.$children[0].Buriedpoint({
          code: "Resource:Resources:edit",
          parent_code: "Resource:Resources",
        });
      } else if (this.indexState == 2 && this.isActive == "1") {
        // 详情
        this.$children[0].Buriedpoint({
          code: "Resource:Resources:detail",
          parent_code: "Resource:Resources",
        });
      }
      this.isActive = index;
    },
  },
};
</script>